<template>
  <div id="paginaCashFlow">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Cash Flow</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <b-row>
              <b-col xl="4" md="4" class="pt-1">
                <label for="dataInizio" class="h5">Dal</label>
                <ejs-datepicker
                  id="dataInizio"
                  v-model="dataInizio"
                  :format="settings.formatoData"
                />
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <label for="dataFine" class="h5">Al</label
                >
                <ejs-datepicker
                  id="dataFine"
                  v-model="dataFine"
                  :format="settings.formatoData"
                />
              </b-col>
              <b-col xl="2" md="2" class="mt-3">
                <ejs-button id="cercaCashFlow" cssClass="e-flat"
                  @click.native="cercaCashFlow()">Cerca</ejs-button>
              </b-col>
            </b-row>
            <!-- export XLS arricchito con i movimenti esterni presenti nel file excel caricato -->
            <b-row>
              <b-col xl="8" md="8" class="pt-1">
                <label for="fileMovimentiEsterni" class="h5">File excel movimenti esterni</label>
                <input
                  id="fileMovimentiEsterni"
                  ref="fileMovimentiEsterni"
                  type="file"
                  class="form-control"
                  accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  @change="selezionaFileMovimentiEsterni"
                >
              </b-col>
              <b-col xl="2" md="2" class="mt-3">
                <ejs-button id="exportXls" cssClass="e-flat" :disabled="loading"
                  @click.native="exportXlsCashFlow()">Export XLS</ejs-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="3" md="3" class="pt-1">
                <label for="saldoInizBPM" class="h5">Saldo Iniziale BPM Ordinario</label>
                <ejs-numerictextbox
                  id="saldoInizBPM"
                  v-model="saldoIniz[0]" floatLabelType="Never" cssClass="" format="###.# €"
                  showSpinButton="false" showClearButton="true" />
              </b-col>
              <b-col xl="3" md="3" class="pt-1">
                <label for="saldoInizBPMcantelli" class="h5">Saldo Iniziale BPM Cantelli</label>
                <ejs-numerictextbox
                  id="saldoInizBPMcantelli"
                  v-model="saldoIniz[1]" floatLabelType="Never" cssClass="" format="###.# €"
                  showSpinButton="false" showClearButton="true" />
              </b-col>
              <b-col xl="3" md="3" class="pt-1">
                <label for="saldoInizBPMsc" class="h5">Saldo Iniziale BPM Sistema Culturale</label>
                <ejs-numerictextbox
                  id="saldoInizBPMsc"
                  v-model="saldoIniz[2]" floatLabelType="Never" cssClass="" format="###.# €"
                  showSpinButton="false" showClearButton="true" />
              </b-col>
              <b-col xl="3" md="3" class="pt-1">
                <label for="saldoInizBPMAMO" class="h5">Saldo Iniziale BPM Accademia AMO</label>
                <ejs-numerictextbox
                  id="saldoInizBPMAMO"
                  v-model="saldoIniz[3]" floatLabelType="Never" cssClass="" format="###.# €"
                  showSpinButton="false" showClearButton="true" />
              </b-col>
              <b-col xl="3" md="3" class="pt-1">
                <label for="saldoInizIntesa" class="h5">Saldo Iniziale Banca Intesa</label>
                <ejs-numerictextbox
                  id="saldoInizIntesa"
                  v-model="saldoIniz[4]" floatLabelType="Never" cssClass="" format="###.# €"
                  showSpinButton="false" showClearButton="true" />
              </b-col>
              <b-col xl="3" md="3" class="pt-1">
                <label for="saldoInizSella" class="h5">Saldo Iniziale Banca Sella</label>
                <ejs-numerictextbox
                  id="saldoInizSella"
                  v-model="saldoIniz[5]" floatLabelType="Never" cssClass="" format="###.# €"
                  showSpinButton="false" showClearButton="true" />
              </b-col>
              <b-col xl="3" md="3" class="pt-1">
                <label for="saldoInizMutuo" class="h5">Saldo Iniziale Conto Mutuo</label>
                <ejs-numerictextbox
                  id="saldoInizMutuo"
                  v-model="saldoIniz[6]" floatLabelType="Never" cssClass="" format="###.# €"
                  showSpinButton="false" showClearButton="true" />
              </b-col>
              <b-col xl="3" md="3" class="pt-1">
                <ejs-button id="aggiornaSaldo" cssClass="e-flat"
                  @click.native="aggiornaSaldoCashFlow()">Aggiorna Saldo</ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, LinkPlugin, AlertPlugin, ProgressPlugin,
  ToastPlugin, SpinnerPlugin,
} from 'bootstrap-vue'
// import Vuexy
// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import {
  DatePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  TextBoxPlugin, NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs'
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import {
  DropDownListPlugin,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(LayoutPlugin)
Vue.use(TabsPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(DatePickerPlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(SpinnerPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(DropDownListPlugin)
Vue.use(DialogPlugin)
Vue.use(DropDownButtonPlugin)
enableRipple(true)
// api
//const apiFornitoriUrl = '/demo/api/soggetto/fornitori'
const apiCashFlowUrl = '/demo/api/cashflow'
const apiContoBancarioUrl = '/demo/api/contobancario'

export default Vue.extend({
  components: {
  },
  data() {
    return {
      loading: false,
      CashFlowFullData: [],
      CashFlowActiveData: [],
      CashFlowActiveRow: 0,
      ContiBancariFullData: [],
      ContiBancariMap: {},
      elencoBanche: [],
      bancaFields: { value: "val", text: "label" },
      bancaIndex: -1,
      dataInizio: null,
      dataFine: null,
      // file excel con i movimenti esterni al database, per l'export XLS
      fileMovimentiEsterni: null,
      // conti: BPMordinario, BPMcantelli, BPMsc, BPMAMO, Intesa, Sella, mutuo
      saldoIniz: [0, 0, 0, 0, 0, 0, 0],
      // gestione elementi nascosti
      nonMostrare: false,
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        firstDayOfWeek: 1,
      },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,
    }
  },
  created() {
    // log
    console.log('Pagina CashFlow Creata')
    // inizializzazione elenchi dal backend
    // chiamate API
    // TODO: ottenere saldi iniziali ultimo aggiornamento DB

    // TODO gestione status 401 con redirect a login
    if (localStorage.getItem('userData') !== null) {
      console.log('Recupero elenchi dal backend')
      useJwt.get(apiContoBancarioUrl).then((d) => {
        console.log("Elenco banche");
        console.log(d.data);
        this.ContiBancariFullData = d.data

        this.ContiBancariFullData.forEach((obj, idx) => {
          // console.log(obj.nome)
          // console.log(obj.id)
          //mapping conti -> posizione in contiBancari
          // BPMordinario, BPMcantelli, BPMsc, BPMAMO, Intesa, Sella, mutuo
          if (obj.nome === 'BPM Ordinario')
            this.ContiBancariMap['BPMordinario'] = idx
          if (obj.nome === 'Conto BPM Premio Cantelli')
            this.ContiBancariMap['BPMcantelli'] = idx
          if (obj.nome === 'Conto BPM Sistema Culturale')
            this.ContiBancariMap['BPMsc'] = idx
          if (obj.nome === 'Conto BPM Accademia AMO')
            this.ContiBancariMap['BPMAMO'] = idx

          if (obj.nome === 'Conto Banca Intesa')
            this.ContiBancariMap['Intesa'] = idx
          if (obj.nome === 'Conto Banca Sella')
            this.ContiBancariMap['Sella'] = idx
          if (obj.nome === 'Conto Mutuo')
            this.ContiBancariMap['mutuo'] = idx

          this.elencoBanche.push({label: obj.nome, val: obj.id})
        })
        // segnalo i conti attesi che non sono stati trovati per nome nel backend
        // (l'ordine corrisponde agli indici di saldoIniz)
        const contiAttesi = ['BPMordinario', 'BPMcantelli', 'BPMsc', 'BPMAMO', 'Intesa', 'Sella', 'mutuo']
        const contiMancanti = contiAttesi.filter(c => this.ContiBancariMap[c] === undefined)
        if (contiMancanti.length > 0) {
          console.warn('Conti bancari non trovati per nome (saldo considerato 0):', contiMancanti)
        }
        // inizializzo i campi "saldo iniziale" con l'ultimoSaldo dei conti
        // (nuovo array per far scattare la reattivita' di Vue 2 sui v-model saldoIniz[i])
        this.saldoIniz = contiAttesi.map((c) => {
          const idx = this.ContiBancariMap[c]
          const conto = idx !== undefined ? this.ContiBancariFullData[idx] : null
          return conto && conto.ultimoSaldo ? +conto.ultimoSaldo : 0
        })
      });
    } else {
      console.log('Non trovo UserData, prova ancora')
    }

  },
  // mounted() {
  // },
  methods: {
    ordinaRighe() {
      this.CashFlowFullData.sort(function (a, b) {
        return new Date(a.data) - new Date(b.data);
      });
    },
    cercaCashFlow() {
      console.log("cercaCashFlow")
      const apiRicerca = apiCashFlowUrl + '/ricercaintervallo'
      const datiDaInviare = {
        'datainizio': this.dataInizio,
        'datafine': this.dataFine,
      }
      useJwt.post(apiRicerca, datiDaInviare).then((d) => {
        //console.log("Elenco Cash Flow");
        //console.log(d.data);
        if (d.data.length > 0) 
          this.CashFlowFullData = d.data;
          this.CashFlowFullData.forEach((obj) => {
            if (obj.data) {
              const tmp = obj.data.split('T')[0]
              const d = new Date(tmp)
              obj.data = d
            }
            // se soggetto di tipo fornitore devo mostrare nel nome la ragione sociale
          })
        const t = this.calcolaTotali(this.CashFlowFullData)
        this.CashFlowFullData = [...t]

        this.ordinaRighe()
      });
    },
    selezionaFileMovimentiEsterni(event) {
      const [file] = event.target.files
      this.fileMovimentiEsterni = file || null
    },
    // invia il file excel dei movimenti esterni insieme all'intervallo selezionato
    // e scarica l'XLS del cashflow restituito dal backend
    exportXlsCashFlow() {
      if (!this.dataInizio || !this.dataFine) {
        this.makeToast('warning', 'Export XLS', 'Selezionare le date Dal e Al')
        return
      }
      if (!this.fileMovimentiEsterni) {
        this.makeToast('warning', 'Export XLS', 'Selezionare il file excel dei movimenti esterni')
        return
      }
      const formData = new FormData()
      formData.append('file', this.fileMovimentiEsterni)
      formData.append('datainizio', new Date(this.dataInizio).toISOString())
      formData.append('datafine', new Date(this.dataFine).toISOString())

      this.loading = true
      useJwt.post(`${apiCashFlowUrl}/export_xls`, formData, { responseType: 'blob' }).then((res) => {
        // nome file dall'header Content-Disposition, se esposto dal backend
        const disposition = res.headers['content-disposition'] || ''
        const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)
        const nomeFile = match ? decodeURIComponent(match[1]) : 'cashflow.xlsx'

        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', nomeFile)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      }).catch((err) => {
        console.error('Errore export XLS cashflow', err)
        this.makeToast('danger', 'Export XLS', 'Errore durante la generazione del file XLS')
      }).finally(() => {
        this.loading = false
      })
    },
    // saldo corrente di un conto identificato dalla chiave in ContiBancariMap;
    // 0 se il conto non e' presente nell'elenco restituito dal backend
    saldoConto(chiave) {
      const idx = this.ContiBancariMap[chiave]
      if (idx === undefined || !this.ContiBancariFullData[idx]) return 0
      return this.ContiBancariFullData[idx].saldoBanca
    },
    calcolaTotali(cashFlowData) {
      this.ContiBancariFullData.forEach((obj) => {
        console.log(obj)
        if (obj.ultimoSaldo)
          obj.saldoBanca = +obj.ultimoSaldo
        else
          obj.saldoBanca = 0
      })
      //console.log("CONTI BANCARI")
      //console.log(this.ContiBancariFullData)

      cashFlowData.forEach((obj) => {
        // console.log("entrate: ", obj.entrate)
        // console.log("uscite: ", obj.uscite)
        const i = this.ContiBancariFullData.findIndex((x) => x.id === obj.banca);
        // console.log(i)
        if (i >= 0) {
          console.log(this.ContiBancariFullData[i])
          if (obj.entrate !== 0) {
            // mi assicuro che entrate non sia una stringa
            obj.entrate = +obj.entrate
            this.ContiBancariFullData[i].saldoBanca = this.ContiBancariFullData[i].saldoBanca + obj.entrate
          }
          if (obj.uscite !== 0) {
            obj.uscite = +obj.uscite
            this.ContiBancariFullData[i].saldoBanca = this.ContiBancariFullData[i].saldoBanca - obj.uscite
          }
          // conti: BPMordinario, BPMcantelli, BPMsc, BPMAMO, Intesa, Sella, mutuo
          obj.saldoBPMordinario = this.saldoConto('BPMordinario')
          obj.saldoBPMcantelli = this.saldoConto('BPMcantelli')
          obj.saldoBPMsc = this.saldoConto('BPMsc')
          obj.saldoBPMAMO = this.saldoConto('BPMAMO')
          obj.saldoIntesa = this.saldoConto('Intesa')
          obj.saldoSella = this.saldoConto('Sella')
          obj.saldoMutuo = this.saldoConto('mutuo')
          // console.log("saldo BPM ordinario:", obj.saldoBPMordinario)
          // console.log("saldo BPM cantelli:", obj.saldoBPMcantelli)
          // console.log("saldo BPM Sistema Culturale:", obj.saldoBPMsc)
          // console.log("saldo BPM AMO:", obj.saldoBPMAMO)
          // console.log("saldo Intesa:", obj.saldoIntesa)
          // console.log("saldo Sella:", obj.saldoSella)
          // console.log("saldo conto mutuo:", obj.saldoMutuo)
        }
      })
      return cashFlowData
    },
    aggiornaSaldoCashFlow() {
      this.ContiBancariFullData.forEach((obj) =>
      {
          if (obj.nome === 'BPM ordinario')
            obj.ultimoSaldo = this.saldoIniz[0]
          if (obj.nome === 'Conto BPM Premio Cantelli')
            obj.ultimoSaldo = this.saldoIniz[1]
          if (obj.nome === 'Conto BPM Sistema Culturale')
            obj.ultimoSaldo = this.saldoIniz[2]
          if (obj.nome === 'Conto BPM Accademia AMO')
            obj.ultimoSaldo = this.saldoIniz[3]
          if (obj.nome === 'Conto Banca Intesa')
            obj.ultimoSaldo = this.saldoIniz[4]
          if (obj.nome === 'Conto Banca Sella')
            obj.ultimoSaldo = this.saldoIniz[5]
          if (obj.nome === 'Conto Mutuo')
            obj.ultimoSaldo = this.saldoIniz[6]
      })
      // salvo i nuovi saldi iniziali anche sul backend (un PATCH per conto)
      const richieste = this.ContiBancariFullData.map((obj) => {
        const datiDaInviare = {
          id: obj.id,
          ultimoSaldo: obj.ultimoSaldo,
          dataSaldo: new Date().toISOString(),
        }
        return useJwt.patch(`${apiContoBancarioUrl}/${obj.id}`, datiDaInviare)
      })
      Promise.all(richieste).then(() => {
        console.log('Saldi iniziali conti bancari aggiornati sul backend')
      }).catch((err) => {
        console.error('Errore aggiornamento saldi conti bancari', err)
      })
      const t = this.calcolaTotali(this.CashFlowFullData)
      this.CashFlowFullData = [...t]
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    noop() {
      console.log("premuto enter")
    },

  },
  computed: {
    hasChanged() {
      return Object.keys(this.CashFlowActiveData).some(field => this.CashFlowActiveData[field] !== this.CashFlowActiveData[field])
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
